import { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import Sidebar from '../../components/Sidebar';
import Loading from '../../components/Loading';
import { useNavigate } from 'react-router-dom';
import { FaCopy, FaTrash } from 'react-icons/fa';

// Templates data
const templates = [
  {
    id: 1,
    name: "Lead Magnet",
    description: "Capte leads com ebook gratuito",
    image: "/images/templates/1.png",
    funnel: "[{\"allowBack\":\"true\",\"backgroundColor\":\"#ffffff\",\"blocks\":[{\"type\":\"text\",\"label\":\"Texto\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione um bloco de texto\",\"textColor\":\"theme\",\"id\":\"block-209ef95d-5b42-425b-b712-4c0893721e10\",\"config\":{},\"content\":\"<h3 class=\\\"ql-align-center\\\"><strong>Essas 3 receitas me fizeram perder 5kg em apenas 10 dias!</strong></h3>\"},{\"type\":\"image\",\"label\":\"Imagem\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione uma imagem\",\"id\":\"block-0b9768f1-c847-469e-95b2-a3633d0dea87\",\"config\":{},\"src\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/8aee638b-1b87-4429-af07-c1a53b2d3657.png\"},{\"id\":\"block-1c65689a-60d1-448c-85ea-76055d7ec1f7\",\"type\":\"button\",\"settings\":{\"delay\":null},\"text\":\"Continuar\",\"style\":\"width: 100%; height: 51px; color: rgb(255, 255, 255); background-color: rgb(11, 117, 71); border-color: rgb(11, 117, 71);\",\"action\":null,\"target\":null,\"targets\":[],\"destinationType\":\"step\",\"label\":\"Continuar\",\"textColor\":\"theme\",\"buttonColor\":\"theme\"},{\"type\":\"text\",\"label\":\"Texto\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione um bloco de texto\",\"textColor\":\"theme\",\"id\":\"block-02c06d94-18c6-494f-a8ea-ca918237885d\",\"config\":{},\"content\":\"<p class=\\\"ql-align-center\\\">☝🏼 Toque em \\\"continuar\\\" para iniciar!</p>\"}],\"id\":\"step-020ab508-55b3-4ff2-a148-ed79f9194eb6\",\"showLogo\":\"false\",\"showProgress\":\"false\",\"title\":\"Etapa 1\",\"unique_visitor\":2,\"visitors\":\"0\",\"visits\":\"0\",\"position\":{\"x\":468.9953055280614,\"y\":-383.73125961299223},\"isDarkMode\":true,\"logo\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/140f7d2b-3b07-454d-8c7b-a865de5491db.png\"}]",
    settings: "{\"logo\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/140f7d2b-3b07-454d-8c7b-a865de5491db.png\",\"logoWidth\":100,\"startStep\":{\"position\":{\"x\":82.60415118236853,\"y\":-131.75920837324009},\"target\":\"step-020ab508-55b3-4ff2-a148-ed79f9194eb6\"},\"backgroundColor\":\"#ffffff\",\"primaryColor\":\"#24921c\",\"secondaryColor\":\"#649665\",\"textColor\":\"#369173\",\"font\":\"Roboto, sans-serif\",\"fontSecondary\":\"Roboto, sans-serif\",\"buttonTextColor\":\"#ffffff\",\"spacing\":15}"
  },
  {
    id: 2,
    name: "Vendas Diretas",
    description: "Funil para vendas de produto",
    image: "/images/templates/2.png",
    funnel: "[{\"allowBack\":\"true\",\"backgroundColor\":\"#ffffff\",\"blocks\":[{\"type\":\"text\",\"label\":\"Texto\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione um bloco de texto\",\"textColor\":\"theme\",\"id\":\"block-e401e4a6-3b96-4f26-b504-f93a14450a55\",\"config\":{},\"content\":\"<h3 class=\\\"ql-align-center\\\"><strong>Descubra 5 receitas de Hamburguers IRRESISTÍVEIS</strong></h3>\"},{\"type\":\"image\",\"label\":\"Imagem\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione uma imagem\",\"id\":\"block-44c49b48-a4ff-4804-88b7-7dd1bc2adb16\",\"config\":{},\"src\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/ae780194-6e83-4a61-afad-21f0b5b9dc96.png\"},{\"id\":\"block-19cd6df3-2c5d-4870-8c7b-c66254fb39cf\",\"type\":\"button\",\"settings\":{\"delay\":null},\"text\":\"Continuar\",\"style\":\"width: 100%; height: 51px; color: rgb(255, 255, 255); background-color: rgb(11, 117, 71); border-color: rgb(11, 117, 71);\",\"action\":null,\"target\":null,\"targets\":[],\"destinationType\":\"step\",\"label\":\"Continuar\",\"textColor\":\"theme\",\"buttonColor\":\"theme\"},{\"type\":\"text\",\"label\":\"Texto\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione um bloco de texto\",\"textColor\":\"theme\",\"id\":\"block-1d512d77-dd52-4063-8ad5-f69f198e30eb\",\"config\":{},\"content\":\"<p class=\\\"ql-align-center\\\">☝🏼 Toque em \\\"continuar\\\" para iniciar!</p>\"}],\"id\":\"step-b47377f7-1495-4471-8ce3-5a81a5174c49\",\"showLogo\":\"false\",\"showProgress\":\"false\",\"title\":\"Etapa 1\",\"unique_visitor\":2,\"visitors\":\"0\",\"visits\":\"0\",\"position\":{\"x\":472.42416106844803,\"y\":-389.4128724685423},\"isDarkMode\":true,\"logo\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/eda1f31d-e3a1-481b-bbfc-d4271b16b927.png\"}]",
    settings: "{\"logo\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/eda1f31d-e3a1-481b-bbfc-d4271b16b927.png\",\"logoWidth\":100,\"startStep\":{\"position\":{\"x\":82.60415118236853,\"y\":-131.75920837324009},\"target\":\"step-020ab508-55b3-4ff2-a148-ed79f9194eb6\"},\"backgroundColor\":\"#141414\",\"primaryColor\":\"#751200\",\"secondaryColor\":\"#6f3434\",\"textColor\":\"#bababa\",\"font\":\"Roboto, sans-serif\",\"fontSecondary\":\"Roboto, sans-serif\",\"buttonTextColor\":\"#ffffff\",\"spacing\":15}"

  },
  {
    id: 3,
    name: "Webinar",
    description: "Inscrições para webinar ao vivo",
    image: "/images/templates/3.png",
    funnel: "[{\"allowBack\":\"true\",\"backgroundColor\":\"#ffffff\",\"blocks\":[{\"type\":\"text\",\"label\":\"Texto\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione um bloco de texto\",\"textColor\":\"theme\",\"id\":\"block-1750963319901-0.9345924195338886\",\"config\":{},\"content\":\"<h3 class=\\\"ql-align-center\\\"><strong>Você está preparado para começar o seu desafio de 21 dias?</strong></h3>\"},{\"type\":\"image\",\"label\":\"Imagem\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione uma imagem\",\"id\":\"block-1751900963706-0.4833989076026345\",\"config\":{},\"src\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/6e18082e-68bc-4001-a182-28b1979f51af.png\"},{\"id\":\"block-ug375odfj\",\"type\":\"button\",\"settings\":{\"delay\":null},\"text\":\"Continuar\",\"style\":\"width: 100%; height: 51px; color: rgb(255, 255, 255); background-color: rgb(11, 117, 71); border-color: rgb(11, 117, 71);\",\"action\":null,\"target\":null,\"targets\":[],\"destinationType\":\"step\",\"label\":\"Continuar\",\"textColor\":\"theme\",\"buttonColor\":\"theme\"},{\"type\":\"text\",\"label\":\"Texto\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione um bloco de texto\",\"textColor\":\"theme\",\"id\":\"text-249d209b-b5e7-4a34-af8e-3238e23cf868\",\"config\":{},\"content\":\"<p class=\\\"ql-align-center\\\">☝🏼 Toque em \\\"continuar\\\" para iniciar!</p>\"}],\"id\":\"step-65397a28-4266-4b36-a398-4e6d64cf8a35\",\"showLogo\":\"false\",\"showProgress\":\"false\",\"title\":\"Etapa 1\",\"unique_visitor\":2,\"visitors\":\"0\",\"visits\":\"0\",\"position\":{\"x\":515.2848553232795,\"y\":-391.66562978370575},\"isDarkMode\":true,\"logo\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/085d6e8c-27a0-4bf2-8941-3a892015d9b5.png\"}]",
    settings: "{\"logo\":\"https://iwxyugwysetdkqtrurmn.supabase.co/storage/v1/object/public/files/images/085d6e8c-27a0-4bf2-8941-3a892015d9b5.png\",\"logoWidth\":100,\"startStep\":{\"position\":{\"x\":82.60415118236853,\"y\":-131.75920837324009},\"target\":\"step-020ab508-55b3-4ff2-a148-ed79f9194eb6\"},\"backgroundColor\":\"#ffffff\",\"primaryColor\":\"#004a8f\",\"secondaryColor\":\"#345d6f\",\"textColor\":\"#3d3d3d\",\"font\":\"Roboto, sans-serif\",\"fontSecondary\":\"Roboto, sans-serif\",\"buttonTextColor\":\"#ffffff\",\"spacing\":15}"
  }
];

export default function Funnels() {
  const [funnels, setFunnels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('blank'); // 'blank', 'template', 'ai'
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    slug: '',
    description: '' // For AI tab
  });
  const [isCreating, setIsCreating] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ show: false, funnel: null });
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDuplicating, setIsDuplicating] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchFunnels = async () => {
      const { data: session } = await supabase.auth.getSession();
      const userId = session?.session?.user?.id;

      console.log(userId);
      if (!userId) return;

      const { data, error } = await supabase
        .from('funnels')
        .select('*')
        .eq('user_uuid', userId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Erro ao carregar funis:', error.message);
      } else {
        setFunnels(data);
      }

      setLoading(false);
    };

    fetchFunnels();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetModal = () => {
    setActiveTab('blank');
    setSelectedTemplate(null);
    setFormData({ title: '', slug: '', description: '' });
    setShowModal(false);
  };

  const handleCreateFunnel = async (e) => {
    e.preventDefault();
    setIsCreating(true);

    try {
      const { data: session } = await supabase.auth.getSession();
      const userId = session?.session?.user?.id;

      if (!userId) {
        alert('Usuário não autenticado');
        return;
      }

      if(formData.title === '' || formData.slug === '') {
        document.getElementById('slug-message').innerHTML = 'Preencha todos os campos';
        return;
      }

      if(formData.slug.length < 6) {
        document.getElementById('slug-message').innerHTML = 'Slug deve ter pelo menos 6 caracteres';
        return;
      }

      const prohibitedSlugs = ['dashboard',
         'editor', 'login', 'register', 'forgot-password', 'reset-password', 'account'];

         if (prohibitedSlugs.includes(formData.slug)) {
          
          document.getElementById('slug-message').innerHTML = 'Slug não permitido';
          return;
        }

      const { data: funnel } = await supabase
        .from('funnels')
        .select('*')
        .eq('slug', formData.slug)
        .single();

      if (funnel) {
        document.getElementById('slug-message').innerHTML = 'Slug já existe';
        return;
      }

      // Determine funnel content based on tab
      let funnelContent, funnelSettings;
      
      if (activeTab === 'template' && selectedTemplate) {
        funnelContent = selectedTemplate.funnel;
        funnelSettings = selectedTemplate.settings;
      } else if (activeTab === 'ai') {
        // For now, use default content - you can integrate AI generation later
        funnelContent = "[{\"allowBack\":\"true\",\"backgroundColor\":\"#ffffff\",\"blocks\":[{\"type\":\"text\",\"content\":\"<h3>Funil criado com IA</h3><p>\" + formData.description + \"</p>\"},{\"type\":\"button\",\"text\":\"Continuar\",\"action\":\"next\"}],\"id\":\"step-1\",\"title\":\"Etapa 1\"}]";
        funnelSettings = "{\"backgroundColor\":\"#ffffff\",\"primaryColor\":\"#0b73a8\",\"textColor\":\"#545454\"}";
      } else {
        // Default blank funnel
        funnelContent = "[{\"allowBack\":\"true\",\"backgroundColor\":\"#ffffff\",\"blocks\":[{\"type\":\"text\",\"label\":\"Texto\",\"icon\":{\"key\":null,\"ref\":null,\"props\":{\"className\":\"text-gray-500\"},\"_owner\":null,\"_store\":{}},\"description\":\"Adicione um bloco de texto\",\"textColor\":\"theme\",\"id\":\"block-1750963319901-0.9345924195338886\",\"config\":{},\"content\":\"<h3 class=\\\"ql-align-center\\\"><strong>Vamos começar</strong></h3><p class=\\\"ql-align-center\\\">Utilize esse componente para adicionar textos.</p>\"},{\"id\":\"block-ug375odfj\",\"type\":\"button\",\"settings\":{\"delay\":null},\"text\":\"Continuar\",\"style\":\"width: 100%; height: 51px; color: rgb(255, 255, 255); background-color: rgb(11, 117, 71); border-color: rgb(11, 117, 71);\",\"action\":null,\"target\":null,\"targets\":[],\"destinationType\":\"step\",\"label\":\"Continuar\",\"textColor\":\"theme\",\"buttonColor\":\"theme\"}],\"id\":\"step-65397a28-4266-4b36-a398-4e6d64cf8a35\",\"showLogo\":\"false\",\"showProgress\":\"false\",\"title\":\"Etapa 1\",\"unique_visitor\":2,\"visitors\":\"0\",\"visits\":\"0\",\"position\":{\"x\":514.1361569682825,\"y\":-240.03744692409705}}]";
        funnelSettings = "{\"logo\":null,\"logoWidth\":20,\"startStep\":{\"target\":\"step-65397a28-4266-4b36-a398-4e6d64cf8a35\",\"position\":{\"x\":43.19802257387616,\"y\":-336.66311028520045}},\"backgroundColor\":\"#ffffff\",\"primaryColor\":\"#0b73a8\",\"secondaryColor\":\"#648396\",\"textColor\":\"#545454\",\"font\":\"Roboto, sans-serif\",\"fontSecondary\":\"Roboto, sans-serif\",\"buttonTextColor\":\"#ffffff\",\"spacing\":10}";
      }

      const { data, error } = await supabase
        .from('funnels')
        .insert([
          {
            title: formData.title,
            slug: formData.slug,
            user_uuid: userId,
            status: 'draft',
            settings: funnelSettings,
            funnel: funnelContent,
          }
        ])
        .select();

      if (error) {
        console.error('Erro ao criar funil:', error.message);
        document.getElementById('slug-message').innerHTML = 'Erro ao criar funil: ' + error.message;
      } else {
        setFunnels(prev => [data[0], ...prev]);
        resetModal();
        navigate(`/dashboard/editor/${data[0].uuid}`);
      }
    } catch (error) {
      console.error('Erro:', error);
      document.getElementById('slug-message').innerHTML = 'Erro inesperado ao criar funil';
    } finally {
      setIsCreating(false);
    }
  };

  function handleDeleteFunnel(funnel) {
    setDeleteModal({ show: true, funnel });
    setDropdownOpen(null);
  }

  const confirmDeleteFunnel = async () => {
    if (!deleteModal.funnel) return;
    
    setIsDeleting(true);
    try {
      const { error } = await supabase
        .from('funnels')
        .delete()
        .eq('uuid', deleteModal.funnel.uuid);

      if (error) {
        console.error('Erro ao deletar funil:', error.message);
        alert('Erro ao deletar funil: ' + error.message);
      } else {
        setFunnels(prev => prev.filter(f => f.uuid !== deleteModal.funnel.uuid));
        setDeleteModal({ show: false, funnel: null });
      }
    } catch (error) {
      console.error('Erro:', error);
      alert('Erro inesperado ao deletar funil');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDuplicateFunnel = async (funnel) => {
    setIsDuplicating(true);
    setDropdownOpen(null);
    
    try {
      const { data: session } = await supabase.auth.getSession();
      const userId = session?.session?.user?.id;

      if (!userId) {
        alert('Usuário não autenticado');
        return;
      }

      // Generate new slug with -copia suffix
      let newSlug = funnel.slug + '-copia';
      let counter = 1;
      
      // Check if slug exists and increment counter if needed
      while (true) {
        const { data: existingFunnel } = await supabase
          .from('funnels')
          .select('uuid')
          .eq('slug', newSlug)
          .single();
        
        if (!existingFunnel) break;
        
        counter++;
        newSlug = funnel.slug + '-copia-' + counter;
      }

      // Se houver um array de steps em funnel.funnel, zere o campo visits de cada step
      let funnelData;
      try {
        funnelData = typeof funnel.funnel === 'string' ? JSON.parse(funnel.funnel) : funnel.funnel;
      } catch (e) {
        funnelData = funnel.funnel;
      }
      if (funnelData && Array.isArray(funnelData.steps)) {
        funnelData.steps = funnelData.steps.map(step => ({
          ...step,
          visits: 0
        }));
      }

      const { data, error } = await supabase
        .from('funnels')
        .insert([
          {
            title: funnel.title + ' (Cópia)',
            slug: newSlug,
            user_uuid: userId,
            status: 'draft',
            settings: funnel.settings,
            funnel: funnel.funnel,
          }
        ])
        .select();

      if (error) {
        console.error('Erro ao duplicar funil:', error.message);
        alert('Erro ao duplicar funil: ' + error.message);
      } else {
        setFunnels(prev => [data[0], ...prev]);
         
      }
    } catch (error) {
      console.error('Erro:', error);
      alert('Erro inesperado ao duplicar funil');
    } finally {
      setIsDuplicating(false);
    }
  };

  return (
    <div className=" min-h-screen">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Meus Funis</h1>
        <p className="text-gray-600">Gerencie e acompanhe seus funis de vendas</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold text-gray-900">Todos os Funis ({funnels.length})</h2>
            <button 
              onClick={() => setShowModal(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md font-medium transition-colors"
            >
              + Novo Funil
            </button>
          </div>
        </div>

        {loading ? (
          <div className="p-8">
            <Loading />
          </div>
        ) : funnels.length === 0 ? (
          <div className="p-8 text-center text-gray-500">
            Nenhum funil encontrado.
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Nome
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Clicks
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Chegaram <br/> ao final
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Iniciaram <br/> Interação
                  </th>
                  
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Slug
                    
                  </th>
                 
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {funnels.map((funnel) => (
                  <tr key={funnel.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="">
                        
                        <a href={`/dashboard/editor/${funnel.uuid}`} className="text-sm font-medium  text-blue-600 hover:text-blue-900 transition-colors flex items-center gap-1"   >
                          {funnel.title.length > 20 ? funnel.title.slice(0,20)  + '...' : funnel.title || 'Sem nome'}
                        </a>
                         
                        </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{funnel.visits || 0}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{funnel.finished || 0}</div>
                    </td>
                
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900 flex items-center gap-2">{funnel.started || 0} 
                      

                      </div>
                    </td>
                    
                    <td className="px-6 py-4 whitespace-nowrap flex items-center gap-2">
                      <div className="text-sm text-gray-900 font-mono bg-gray-100 px-2 py-1 rounded">
                        https://hotify.ai/{(funnel.slug || funnel.uuid.slice(0,15) ) }
                   
                      </div>
                      <a href={`/${funnel.slug}`} target="_blank" className="text-blue-600 hover:text-blue-900 transition-colors flex items-center gap-1 " style={{fontSize: '12px'}} >
                          visitar 
                         
                           <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-3 h-3">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                            </svg>

                        </a>
                    </td>
                    
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                      <div className="relative inline-block text-left">
                        <button
                          type="button"
                          className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-3 py-1 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none"
                          id={`menu-button-${funnel.uuid}`}
                          aria-expanded="true"
                          aria-haspopup="true"
                          onClick={e => {
                            e.stopPropagation();
                            setDropdownOpen(dropdownOpen === funnel.uuid ? null : funnel.uuid);
                          }}
                        >
                          Ações
                          <svg
                            className="-mr-1 ml-2 h-5 w-5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                        {dropdownOpen === funnel.uuid && (
                          <div
                            className="origin-top-right absolute right-0 mt-2 w-40 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby={`menu-button-${funnel.uuid}`}
                            tabIndex="-1"
                          >
                            <div className="py-1" role="none">
                              <a
                                href={`/dashboard/leads/${funnel.uuid}`}
                                target="_blank"
                                className="block px-4 py-2 text-sm text-blue-600 hover:bg-gray-100 hover:text-blue-900 transition-colors"
                                role="menuitem"
                                tabIndex="-1"
                              >
                                Relatório
                              </a>
                              <button
                                className="block w-full text-left px-4 py-2 text-sm text-blue-600 hover:bg-gray-100 hover:text-blue-900 transition-colors"
                                onClick={() => {
                                  setDropdownOpen(null);
                                  navigate(`/dashboard/editor/${funnel.uuid}`);
                                }}
                                role="menuitem"
                                tabIndex="-1"
                              >
                                Editar
                              </button>
                              <button
                                className="block w-full text-left px-4 py-2 text-sm text-blue-600 hover:bg-gray-100 hover:text-blue-900 transition-colors"
                                onClick={() => {
                                  setDropdownOpen(null);
                                  handleDuplicateFunnel(funnel);
                                }}
                                disabled={isDuplicating}
                                role="menuitem"
                                tabIndex="-1"
                              >
                                {isDuplicating ? 'Duplicando...' : 'Duplicar'}
                              </button>
                              <button
                                className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100 hover:text-red-900 transition-colors flex items-center gap-2"
                                onClick={() => handleDeleteFunnel(funnel)}
                                role="menuitem"
                                tabIndex="-1"
                              >
                                <FaTrash className="w-4 h-4" />
                                Excluir
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      
      {/* Modal for creating new funnel */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="px-6 py-4  ">
              <h3 className="text-lg font-semibold text-gray-900">Criar Novo Funil</h3>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex space-x-8 px-6">
                <button
                  onClick={() => setActiveTab('blank')}
                  className={`py-2 px-1 border-b-2 font-medium text-sm ${
                    activeTab === 'blank'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Em branco
                </button>
                <button
                  onClick={() => setActiveTab('template')}
                  className={`py-2 px-1 border-b-2 font-medium text-sm ${
                    activeTab === 'template'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Escolher Template
                </button>
                <button
                  onClick={() => setActiveTab('ai')}
                  style={{display: 'none'}}
                  className={`py-2 px-1 border-b-2 font-medium text-sm ${
                    activeTab === 'ai'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Com Inteligência Artificial
                </button>
              </nav>
            </div>
            
            <form onSubmit={handleCreateFunnel} className="px-6 py-4">
              {/* Tab Content */}
              {activeTab === 'blank' && (
                <div className="space-y-4">
                   
                </div>
              )}

              {activeTab === 'template' && (
                <div className="space-y-6">
                  
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {templates.map((template) => (
                      <div 
                        key={template.id}
                        className={`cursor-pointer border-2 rounded-lg p-4 transition-all ${
                          selectedTemplate?.id === template.id 
                            ? 'border-blue-500 bg-blue-50' 
                            : 'border-gray-200 hover:border-gray-300'
                        }`}
                        onClick={() => setSelectedTemplate(template)}
                      >
                        <div className="aspect-video bg-gray-100 rounded-lg mb-3 flex items-center justify-center">
                          <img 
                            src={template.image} 
                            alt={template.name}
                            className="w-full h-50 object-cover rounded-lg"
                           
                          />
                        
                        </div>
                      
                        {selectedTemplate?.id === template.id && (
                          <div className="mt-2 flex items-center text-blue-600">
                            
                           </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === 'ai' && (
                <div className="space-y-4">
                  
                  
                  <div className="mb-4">
                    <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">
                      Descreva o seu produto *
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      maxLength={300}
                      rows={4}
                      required={activeTab === 'ai'}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                      placeholder="Ex: Vendo um curso de marketing digital para empreendedores que querem aumentar suas vendas online..."
                    />
                    <div className="flex justify-between mt-1">
                      <p className="text-xs text-gray-500">
                        Seja o mais específico possível para melhores resultados
                      </p>
                      <p className="text-xs text-gray-500">
                        {formData.description.length}/300
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Common fields for all tabs */}
              <div className="  pt-4 space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2">
                      Título *
                    </label>
                    <input
                      type="text"
                      id="title"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Digite o título do funil"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="slug" className="block text-sm font-medium text-gray-700 mb-2">
                      Slug *
                    </label>
                    <input
                      type="text"
                      id="slug"
                      name="slug"
                      value={formData.slug}
                      onChange={handleInputChange}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="slug-do-funil"
                      pattern="^[a-z0-9]+(?:-[a-z0-9]+)*$"
                      title="Use apenas letras minúsculas, números e hífens"
                    />
                      <p className="text-xs text-gray-500">
                    Use apenas letras minúsculas, números e hífens (ex: meu-funil-vendas)
                  </p>
                  <div id="slug-message" className="text-sm text-red-500 mb-2"></div>

                  </div>
                </div>
                
                
              </div>
              
              <div className="flex justify-end space-x-3 pt-4  ">
                <button
                  type="button"
                  onClick={resetModal}
                  className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  disabled={isCreating || (activeTab === 'template' && !selectedTemplate)}
                  className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                >
                  {isCreating ? 'Criando...' : 'Criar Funil'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteModal.show && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
            <div className="px-6 py-4 border-b border-gray-200">
              <h3 className="text-lg font-semibold text-gray-900">Confirmar Exclusão</h3>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-600 mb-4">
                Tem certeza que deseja excluir o funil "{deleteModal.funnel?.title}"?
              </p>
              <p className="text-sm text-red-600">
                Esta ação não pode ser desfeita e todos os dados do funil serão perdidos permanentemente.
              </p>
            </div>
            <div className="px-6 py-4 bg-gray-50 flex justify-end space-x-3">
              <button
                type="button"
                onClick={() => setDeleteModal({ show: false, funnel: null })}
                disabled={isDeleting}
                className="px-4 py-2 text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={confirmDeleteFunnel}
                disabled={isDeleting}
                className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50 transition-colors flex items-center gap-2"
              >
                {isDeleting ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Excluindo...
                  </>
                ) : (
                  <>
                    <FaTrash className="w-4 h-4" />
                    Excluir
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
